import styled from 'styled-components';
import { media } from '../../../helpers/breakpoints';
import { Panel } from '../../../components/HubPages/components/Panel';

export const ValuationSection = styled.div`
  width: 100%;
  ${media.large} {
    max-width: 760px;
  }
`;

export const PanelHighlighted = styled(Panel)`
  background: ${({ theme }) => theme.colors.GREY_LIGHTER};

  label {
    color: ${({ theme }) => theme.colors.GREY_DARKER};
  }
`;
